import * as React from "react";
import { List, Button, Spin } from "antd";
import styled from "styled-components";
import * as _ from "lodash";

import { Page } from "../../../lib/model/Page";
import { ListItem } from "../../../lib/model/ListItem";
import { Order } from "../../../lib/model/Order";
import { relativeLongMonthDate } from "../../../lib/formatters";
import { OrderCell } from "./OrderCell";

export const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  font-weight: 300;
`;

const SectionHeaderLabel = styled.span`
  font-size: 14px;
  display: inline-block;
  line-height: 1.21;
  color: #061a32;
  margin: 24px 0;
`;

type Props = {
  orders: Page<Order>;
  isLoading: boolean;
  onLoadMore: () => void;
  cursor?: string;
  goToDetail: (id: string) => void;
};

type State = {
  isLoading: boolean;
  data: ListItem<Order>[];
};

const sectionIdentifierForOrder = (order: Order): string => {
  return relativeLongMonthDate(order.startTime);
};

const renderItem = (item: ListItem<Order>, goToDetail: (_ : string) => void): React.ReactElement => {
  if (!!item.sectionHeader) {
    return <SectionHeaderLabel>{item.sectionHeader}</SectionHeaderLabel>;
  }

  return (
    <OrderCell
      isPlaceholder={item.isPlaceholder}
      order={item.item}
      onDetailsClick={order => goToDetail(order.id)}
    />
  );
};

const placeholderData: ListItem<Order>[] = Array(25)
  .fill(0)
  .map(() => {
    return { isPlaceholder: true };
  });

export function PagedList({ orders, isLoading, cursor, onLoadMore, goToDetail }: Props) {
  const data = orders.results.map(i => { return { isPlaceholder: false, item: i }})
  const sections = _.uniq(
    data.map(d => sectionIdentifierForOrder(d.item!))
  );

  const sectionedData: ListItem<Order>[] = _.flatMap(sections, s => [
    { isPlaceholder: false, sectionHeader: s },
    ...data.filter(d => sectionIdentifierForOrder(d.item!) === s)
  ]);

  const loadMore = cursor && (
    <div
      style={{
        textAlign: "center",
        marginTop: 18,
        height: 33
      }}
    >
      {isLoading ?
        <Spin /> : 
        <Button style={{ borderRadius: 0 }} onClick={onLoadMore}>
          mehr laden
        </Button>
      }
    </div>
  );
  
  return (
    <List
      itemLayout="horizontal"
      loadMore={loadMore}
      dataSource={isLoading && orders.results.length === 0 ? placeholderData : sectionedData}
      renderItem={(item) => renderItem(item, goToDetail)}
      split={false}
    />
  )
}
